export const planningType = {
  PRODUCTION: 'production',
  LOSSES: 'loss',
  STOCKS: 'stock',
};
